import * as React from 'react';
import {Flex, Title} from '@priority-software/priority-style-react';
import {MenuIcon} from './Menus/MenuIcon';
import {PageSettings} from './Menus/PageSettings';
import RTE from '../../../features/RTE';
import {AutomationRuleBridge} from '../../../features/Automations/components/bridgeWrap';

export const ReconSubformHeader = ({
    topMenu,
    breadCrumbs,
    lowerMenu,
    isRTL,
    funcs,
    currentForm
}) => {
    const tooltipPosition = isRTL ? 'bottom left' : 'bottom right';
    const {closeButton, pageSettings, automationMenu} = topMenu;
    const {undoButton} = lowerMenu;
    return (
        <section className="upper-section">
            <Flex justifyContent="flex-start" alignItems="baseline">
                <section className="bread-crumbs">
                    <Title skin="h3" textColor="primary-500">
                        {currentForm?.title}
                    </Title>
                    <RTE />
                </section>
            </Flex>
            <section className="upper-menu">
                {/*<MacroMenu settingsItems={automationMenu} macroSubmenu={false} />*/}
                <AutomationRuleBridge
                    automationMenu={automationMenu}
                    macroSubmenu={false}
                    componentClasses="spase-x-sm"
                />
                <div className="buttons-row">
                    <MenuIcon name="undo-icon" item={undoButton} />
                    {pageSettings.length > 0 && (
                        <PageSettings
                            topMenu={topMenu}
                            funcs={funcs}
                            isRTL={isRTL}
                            isPopup={true}
                        />
                    )}
                    <MenuIcon
                        name="close-icon"
                        item={closeButton}
                        tooltipPosition={tooltipPosition}
                    />
                </div>
            </section>
        </section>
    );
};
